import { __rest } from "tslib";
import React, { useState } from 'react';
import classnames from 'classnames';
import { Tooltip } from 'antd';
import styles from './locationinput.module.scss';
import { CloseCircleIcon } from '@web-common/components/UI/Icons/icons';
import { getIn18Text } from 'api';
const LocationInput = (_a) => {
    var { value, onCancel, onUpdate, style, className, disabled } = _a, rest = __rest(_a, ["value", "onCancel", "onUpdate", "style", "className", "disabled"]);
    const [closeHover, setCloseHover] = useState(false);
    return (React.createElement("span", Object.assign({ className: classnames('ant-input-affix-wrapper', className, {
            'ant-input-affix-wrapper-disabled': disabled,
        }), style: Object.assign({ maxWidth: 406 }, style) }, rest),
        React.createElement("span", { className: classnames('ant-input', styles.input, {
                'ant-input-disabled': disabled,
            }) },
            React.createElement(Tooltip, { title: getIn18Text('XIUGAIHUIYISHI'), visible: disabled ? false : undefined },
                React.createElement("span", { className: classnames('sirius-ellipsis-text', styles.inputValue, {
                        [styles.inputValueDisabled]: disabled,
                    }), style: { width: '100%', cursor: disabled ? 'not-allowed' : 'pointer' }, onClick: () => !disabled && onUpdate && onUpdate() }, value))),
        React.createElement("span", { className: "ant-input-suffix" },
            React.createElement(Tooltip, { title: getIn18Text('QUXIAOHUIYISHI'), visible: disabled ? false : undefined },
                React.createElement(CloseCircleIcon, { disabled: disabled, onMouseEnter: () => setCloseHover(!0), onMouseLeave: () => setCloseHover(false), enhance: closeHover, className: styles.close, onClick: disabled ? undefined : onCancel })))));
};
export default LocationInput;
